import ContentTypeTrends from './ContentTypeTrends';

export default ContentTypeTrends;